import "./Icones.css";

function Icones({ icone, className }) {
  const getIcone = (icone) => {
    if (icone === "instagram") {
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.5 5.5H16.51M6 1H16C18.7614 1 21 3.23858 21 6V16C21 18.7614 18.7614 21 16 21H6C3.23858 21 1 18.7614 1 16V6C1 3.23858 3.23858 1 6 1ZM15 10.37C15.1234 11.2022 14.9813 12.0522 14.5938 12.799C14.2063 13.5458 13.5931 14.1514 12.8416 14.5297C12.0901 14.9079 11.2384 15.0396 10.4078 14.9059C9.57713 14.7723 8.80976 14.3801 8.21484 13.7852C7.61992 13.1902 7.22773 12.4229 7.09407 11.5922C6.9604 10.7616 7.09207 9.90989 7.47033 9.15837C7.84859 8.40685 8.45419 7.79374 9.20098 7.40624C9.94778 7.01874 10.7978 6.87659 11.63 7C12.4789 7.12588 13.2649 7.52146 13.8717 8.12831C14.4785 8.73515 14.8741 9.52108 15 10.37Z"
            stroke="#C4C4C4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    if (icone === "pinterest") {
      return (
        <svg
          width="19"
          height="24"
          viewBox="0 0 19 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.29831e-05 8.42292C8.29831e-05 7.40774 0.177545 6.44866 0.527249 5.55352C0.861366 4.68409 1.35777 3.88613 1.99001 3.20215C2.62096 2.52716 3.34298 1.94347 4.13521 1.46798C4.94803 0.976245 5.82801 0.605264 6.74755 0.366673C7.6782 0.122299 8.63649 -0.000941302 9.59869 5.41298e-06C11.0849 5.41298e-06 12.4681 0.314478 13.7508 0.940815C15.0167 1.55573 16.0942 2.49941 16.8707 3.67321C17.6719 4.86716 18.0699 6.2177 18.0699 7.72352C18.0699 8.62648 17.9812 9.50988 17.7998 10.3737C17.6217 11.237 17.3386 12.0753 16.9568 12.8699C16.593 13.6391 16.1172 14.3501 15.545 14.9799C14.9699 15.5996 14.2734 16.0944 13.4989 16.4335C12.6581 16.802 11.7485 16.9875 10.8305 16.9776C10.1924 16.9776 9.55563 16.8276 8.92668 16.5262C8.29774 16.226 7.84625 15.8137 7.57484 15.2852C7.47959 15.6519 7.3491 16.1817 7.17555 16.8746C7.00853 17.5661 6.89631 18.0124 6.84672 18.2147C6.79453 18.4156 6.69797 18.751 6.55704 19.2155C6.46147 19.5591 6.33887 19.8946 6.19038 20.2189L5.7415 21.0984C5.54738 21.4758 5.33037 21.841 5.09168 22.1919C4.8555 22.5338 4.56321 22.9422 4.21481 23.4119L4.02038 23.4811L3.8912 23.3402C3.75158 21.8618 3.67981 20.9771 3.67981 20.6848C3.67981 19.8196 3.78289 18.8488 3.98645 17.771C4.1861 16.6945 4.50188 15.3413 4.92596 13.7142C5.35004 12.0883 5.59275 11.1318 5.65799 10.8487C5.35918 10.2393 5.20781 9.44333 5.20781 8.46468C5.20781 7.68307 5.45182 6.95104 5.94115 6.26206C6.43178 5.5757 7.05159 5.23252 7.80319 5.23252C8.37864 5.23252 8.8249 5.42304 9.1446 5.80536C9.46559 6.18638 9.62218 6.66657 9.62218 7.25246C9.62218 7.87358 9.41601 8.77263 9.00106 9.94832C8.58611 11.1253 8.37994 12.0035 8.37994 12.5868C8.37994 13.1779 8.59133 13.6724 9.01411 14.06C9.43134 14.4477 9.9831 14.6578 10.5525 14.6458C11.0693 14.6458 11.5482 14.5284 11.9931 14.2922C12.4311 14.063 12.8103 13.7356 13.101 13.3358C13.7341 12.4671 14.1855 11.4796 14.428 10.4324C14.5533 9.88177 14.6498 9.35852 14.7099 8.86658C14.7738 8.37204 14.8012 7.90489 14.8012 7.46124C14.8012 5.83407 14.2845 4.56574 13.2575 3.65755C12.2254 2.74936 10.8814 2.29788 9.22811 2.29788C7.34779 2.29788 5.77543 2.90595 4.51623 4.126C3.25573 5.34213 2.62156 6.8884 2.62156 8.7635C2.62156 9.17714 2.6842 9.57643 2.80294 9.96267C2.91907 10.3476 3.04564 10.6542 3.18266 10.8813C3.31836 11.1044 3.44624 11.3223 3.56237 11.5233C3.67981 11.7242 3.74114 11.8678 3.74114 11.9539C3.74114 12.2175 3.67198 12.5607 3.53236 12.9847C3.38752 13.4088 3.21658 13.6202 3.01041 13.6202C2.99084 13.6202 2.90994 13.6059 2.76901 13.5758C2.28094 13.4301 1.84018 13.1578 1.49155 12.7864C1.12154 12.4015 0.829528 11.9487 0.631639 11.4528C0.434314 10.9587 0.280623 10.4483 0.172326 9.92744C0.0553201 9.43456 -0.00250212 8.92949 8.29831e-05 8.42292Z"
            fill="#C4C4C4"
          />
        </svg>
      );
    }
    if (icone === "email") {
      return (
        <svg
          width="53"
          height="42"
          viewBox="0 0 53 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M52.3083 5.23083C52.3083 2.35387 49.9545 0 47.0775 0H5.23083C2.35387 0 0 2.35387 0 5.23083V36.6158C0 39.4928 2.35387 41.8467 5.23083 41.8467H47.0775C49.9545 41.8467 52.3083 39.4928 52.3083 36.6158V5.23083ZM47.0775 5.23083L26.1542 18.3079L5.23083 5.23083H47.0775ZM47.0775 36.6158H5.23083V10.4617L26.1542 23.5388L47.0775 10.4617V36.6158Z"
            fill="#515151"
          />
        </svg>
      );
    }
    if (icone === "setaComCirculo") {
      return (
        <svg
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.03952 19.2334C1.06135 29.2597 9.20701 37.37 19.2333 37.3481C29.2597 37.3263 37.37 29.1806 37.3481 19.1543C37.3263 9.12796 29.1806 1.0177 19.1543 1.03953C9.12795 1.06136 1.01769 9.20701 1.03952 19.2334Z"
            stroke="#215044"
            strokeWidth="1.49756"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.1777 12.1079L12.1086 19.2079L19.2086 26.2771"
            stroke="#215044"
            strokeWidth="1.49756"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.2773 19.1777L12.1081 19.2086"
            stroke="#215044"
            strokeWidth="1.49756"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
    if (icone === "setaVoltarSimples") {
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L2 12L12 22"
            stroke="#215044"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 12L2 12"
            stroke="#215044"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }
  };

  return (
    <div className={`container-icones container-icone-${icone}`}>
      <div className={`${className}`}>{getIcone(icone)}</div>
    </div>
  );
}

export default Icones;
